module.exports = __webpack_public_path__ + "img/profile-v2.815cf037.svg";